import type { LogicFilterValue } from '../../fetchSurvey/types/survey';

/** Parsed `{rowId}_{suffix}` composite key (matrix column id or slider score). */
export type CompositeKey = {
  rowId: string;
  suffix: string;
};

/** Parses matrix/slider skip-logic composite keys such as `rowId_columnId` or `rowId_5`. */
export function parseCompositeKey(value: LogicFilterValue): CompositeKey | null {
  if (typeof value !== 'string' || !value.includes('_')) {
    return null;
  }

  const separatorIndex = value.lastIndexOf('_');
  const rowId = value.slice(0, separatorIndex);
  const suffix = value.slice(separatorIndex + 1);

  if (!rowId || !suffix) {
    return null;
  }

  return { rowId, suffix };
}
